import { defineTour } from '../../types';

/**
 * T01 — Tenant workspace orientation (brief §7): the menu (or the menu button
 * and the bottom navigation below 1024px), the dashboard's own work, the
 * language switch and Help. It names no restricted area: the menu shows only
 * what this seat may reach, and the dashboard step spotlights whichever view
 * this seat has. Works with zero business records.
 *
 * Copy: `guidance.tours.T01.*` — draft, for native-language review.
 */
export const T01 = defineTour({
  id: 'T01',
  version: 1,
  portal: 'tenant',
  titleKey: 'guidance.tours.T01.title',
  summaryKey: 'guidance.tours.T01.summary',
  eligible: (ctx) => ctx.portal === 'tenant',
  pageRoutes: ['tenant.dashboard'],
  steps: [
    {
      id: 't01-welcome',
      anchor: null,
      titleKey: 'guidance.tours.T01.welcome.title',
      bodyKey: 'guidance.tours.T01.welcome.body',
    },
    {
      id: 't01-navigation',
      anchor: ['tenant.shell.nav', 'tenant.shell.menu'],
      titleKey: 'guidance.tours.T01.navigation.title',
      bodyKey: 'guidance.tours.T01.navigation.body',
    },
    {
      id: 't01-bottom-navigation',
      anchor: 'tenant.shell.bottom-nav',
      when: (ctx) => !ctx.isWide,
      titleKey: 'guidance.tours.T01.bottomNavigation.title',
      bodyKey: 'guidance.tours.T01.bottomNavigation.body',
    },
    {
      id: 't01-your-work',
      anchor: ['tenant.dashboard.your-work', 'tenant.dashboard.figures'],
      route: 'tenant.dashboard',
      titleKey: 'guidance.tours.T01.yourWork.title',
      bodyKey: 'guidance.tours.T01.yourWork.body',
    },
    {
      id: 't01-language',
      anchor: 'tenant.shell.language',
      titleKey: 'guidance.tours.T01.language.title',
      bodyKey: 'guidance.tours.T01.language.body',
    },
    {
      id: 't01-help',
      anchor: 'tenant.shell.help',
      titleKey: 'guidance.tours.T01.help.title',
      bodyKey: 'guidance.tours.T01.help.body',
    },
  ],
});
